// extracted by mini-css-extract-plugin
export default {"wrap":"eK-z","fullWidth":"fK-z","hideOnDesktop":"gK-z","content":"hK-z","hasOpenedNav":"iK-z","crumbsList":"jK-z","dropdownsWrap":"kK-z"};